import _ from "lodash";

const storage_instances = {};

class PrefixedStorage {
  constructor(prefix, storage) {
    this.prefix = prefix;
    this.storage = _.defaultTo(storage, localStorage);
  }

  getKey(keyName) {
    return `${this.prefix}_${keyName}`;
  }

  setItem(keyName, keyValue) {
    this.storage.setItem(this.getKey(keyName), keyValue);
  }

  removeItem(keyName) {
    this.storage.removeItem(this.getKey(keyName));
  }

  getItem(keyName) {
    return this.storage.getItem(this.getKey(keyName));
  }

  clear() {
    // Keys that should persist even after logout
    const keysToPersist = ['autoLogout'];
    // we have to iterate over all items of the storage that start with the prefix
    let keysToRemove = [];
    for (let len = this.storage.length, i = 0; i < len; i++) {
      const key = this.storage.key(i);
      const keyName = key.split('_')[1];

      if (
        _.startsWith(key, this.prefix) &&
        !_.includes(keysToPersist, keyName)
      ) {
        keysToRemove.push(key);
      }
    }

    for (const key of keysToRemove) {
      this.storage.removeItem(key);
    }
  }
}

export function getStorage(prefix) {
  if (!prefix) {
    return
  }
  if (_.has(storage_instances)) {
    return _.get(storage_instances, prefix);
  }
  return (storage_instances[prefix] = new PrefixedStorage(prefix));
}
